import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-the-universal-process-ideate',
	templateUrl: './cig-the-universal-process-ideate.component.html',
	styleUrls: ['./cig-the-universal-process-ideate.component.scss']
})
export class CigTheUniversalProcessIdeateComponent implements OnInit {
	@Input() slides;
	@Input() foursightassets;
	@Input() author;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
